/* tslint:disable */
import {
  Lease,
  ChartOfAccount
} from '../index';

declare var Object: any;
export interface RecurringChargeInterface {
  "amount": number;
  "chart_of_account_id": number;
  "frequency": string;
  "start_date": Date;
  "end_date": Date;
  "occurences"?: number;
  "description"?: string;
  "lease_id": number;
  "status"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  lease?: Lease;
  chartOfAccount?: ChartOfAccount;
}

export class RecurringCharge implements RecurringChargeInterface {
  "amount": number;
  "chart_of_account_id": number;
  "frequency": string;
  "start_date": Date;
  "end_date": Date;
  "occurences": number;
  "description": string;
  "lease_id": number;
  "status": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  lease: Lease;
  chartOfAccount: ChartOfAccount;
  constructor(data?: RecurringChargeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RecurringCharge`.
   */
  public static getModelName() {
    return "RecurringCharge";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RecurringCharge for dynamic purposes.
  **/
  public static factory(data: RecurringChargeInterface): RecurringCharge{
    return new RecurringCharge(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RecurringCharge',
      plural: 'RecurringCharges',
      path: 'RecurringCharges',
      idName: 'id',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "frequency": {
          name: 'frequency',
          type: 'string'
        },
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "occurences": {
          name: 'occurences',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'ACTIVE'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
      }
    }
  }
}
